// Google Tag Manager utility for conditional loading
declare global {
  interface Window {
    dataLayer: any[];
    gtm: any;
  }
}

const GTM_ID = 'GTM-KCHMGC2W';

/**
 * Initialize Google Tag Manager only in production environments
 */
export function initializeGTM(): void {
  // Skip GTM initialization in development environment
  if (import.meta.env.DEV) {
    console.log('GTM: Skipped initialization in development environment');
    return;
  }

  // Skip if GTM is already loaded
  if (window.gtm) {
    console.log('GTM: Already initialized');
    return;
  }

  try {
    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    
    // Add GTM initialization to dataLayer
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    // Create and inject GTM script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    
    // Insert noscript after body opening tag
    if (document.body.firstChild) {
      document.body.insertBefore(noscript, document.body.firstChild);
    } else {
      document.body.appendChild(noscript);
    }

    // Mark as initialized
    window.gtm = true;
    
    console.log('GTM: Successfully initialized');
  } catch (error) {
    console.error('GTM: Failed to initialize', error);
  }
}

/**
 * Push events to GTM dataLayer (with safety checks)
 */
export function gtmPush(data: Record<string, any>): void {
  if (import.meta.env.DEV) {
    console.log('GTM Event (dev mode):', data);
    return;
  }

  if (window.dataLayer) {
    window.dataLayer.push(data);
  } else {
    console.warn('GTM: dataLayer not available, event not sent:', data);
  }
} 